import { Fragment } from "react/jsx-runtime";
import ProgressBar from "../../ProgressBar/ProgressBar";
import RecommendationsStyles from "./Recommendations.module.scss";
import { SimpleButton } from "../../Buttons/Buttons";
import { useNavigate } from "react-router-dom";
import NoData from "../../NoData/NoData";
import { ROUTES } from "../../../common/constants";
import Typography from "../../Typography/Typography";
import infoIconSvg from "../../../assets/images/UserTable/InfoIcon.svg";
import Tooltip from "../../Tooltip/Tooltip";
import {
  recommendationsColors,
  recommendationTooltipText,
  standardClausesTooltipText,
} from "../../../modules/vscDashboard/constants";

export default function Recommendations({
  data,
  recommendedPercentage,
  hideGraph = false,
  isClauseCheck,
  loading,
}: any) {
  const navigate = useNavigate();

  if (!data || data.length === 0) {
    return <NoData withBorder={false} />;
  }

  return (
    <div className={RecommendationsStyles.recommendations}>
      <div className={RecommendationsStyles.recommendationsDataContainer}>
        <Fragment>
          {!hideGraph && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "16px",
              }}
            >
              <ProgressBar
                progressPercent={recommendedPercentage}
                dataLength={
                  data?.filter(
                    (summary: any) =>
                      summary?.category !== "Recommendations" &&
                      summary?.category !== "Standard Clauses"
                  )?.length || 0
                }
              />
            </div>
          )}
          <div>
            {data?.length === 0 ? (
              <NoData withBorder={false} />
            ) : (
              data?.map((summary: any, index: number) => (
                <Card summary={summary} index={index} key={index} />
              ))
            )}
          </div>
        </Fragment>
      </div>
      {false && (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <SimpleButton
            onClick={() => {
              navigate(ROUTES.bulkClauseCheck);
            }}
            style={{ borderColor: "#3474E0" }}
          >
            <Typography fontSize={12}>View all</Typography>
          </SimpleButton>

          <SimpleButton
            onClick={() => {
              navigate(ROUTES.clauseSummary);
            }}
            style={{ borderColor: "#3474E0" }}
          >
            <Typography fontSize={12}>Summary</Typography>
          </SimpleButton>
        </div>
      )}
    </div>
  );
}

const Card = ({ summary, index }: any) => {
  const isStandardClauses = summary?.category === "Standard Clauses";
  const isRecommendations = summary?.category === "Recommendations";
  const showInfoIcon = isStandardClauses || isRecommendations;
  const tooltipText = isStandardClauses
    ? standardClausesTooltipText
    : recommendationTooltipText;

  const circleColor =
    recommendationsColors[index % recommendationsColors.length];

  return (
    <div className={RecommendationsStyles.recommendation}>
      <div className={RecommendationsStyles.recommendationText}>
        {!showInfoIcon && (
          <div
            className={RecommendationsStyles.circle}
            style={{ backgroundColor: circleColor }}
          ></div>
        )}
        <Typography
          fontSize={12}
          fontWeight={400}
          color={showInfoIcon ? "black" : "#595d72"}
        >
          {summary?.category}
        </Typography>
        {showInfoIcon && (
          <Tooltip
            title={
              <Typography fontSize={12} fontWeight={400}>
                {tooltipText}
              </Typography>
            }
            placement="right"
          >
            <img src={infoIconSvg} alt="" width={16} height={16} />
          </Tooltip>
        )}
      </div>
      <div className={RecommendationsStyles.recommendationCount}>
        {summary?.count}
      </div>
    </div>
  );
};
